import { render, staticRenderFns } from "./BookingRequests.vue?vue&type=template&id=aca46c30&scoped=true"
import script from "./BookingRequests.vue?vue&type=script&setup=true&lang=ts"
export * from "./BookingRequests.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BookingRequests.vue?vue&type=style&index=0&id=aca46c30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aca46c30",
  null
  
)

export default component.exports